import { IAdditionalModules } from "~common/price-calculate-screen-v2/types";

export const MAX_COUNT_USERS = 4900;
export const MIN_COUNT_USERS = 1;

export const ADDITIONAL_MODULES: IAdditionalModules[] = [
        {
            label: 'RECORDS',
            title: 'Запись разговоров',
            promptText: 'Модуль записывает все разговоры за месяц. Звонки можно прослушать в ускоренном режиме, скачать или автоматически загрузить в CRM. Доступ к записям – 1 год.'
        },
        {
            label: 'STEREO_RECORDS',
            title: 'Стереозапись',
            promptText: 'Улучшенное качество записи и сохранение в стереоформате. Актуально при интеграции с сервисами речевой аналитики.'
        },
        {
            label: 'QUALITY_SCORE',
            title: 'Оценка качества',
            promptText: 'После окончания разговора модуль попросит оценить качество обслуживания от 1 до 5.'
        },
        {
            label: 'ANALYTICS',
            title: 'Бизнес аналитика',
            promptText: '3 отчета + онлайн-дашборд. Отчеты содержат основные показатели: количество звонков, продолжительность разговоров, число пропущенных, сколько ждут клиенты, среднюю оценку качества. Дашборд покажет число операторов и клиентов на линии в режиме реального времени.'
        }
]


